var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H11.25V11.25H2V5C2 3.34315 3.34315 2 5 2ZM4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L5.93934 7L4.46967 8.46967C4.17678 8.76256 4.17678 9.23744 4.46967 9.53033C4.76256 9.82322 5.23744 9.82322 5.53033 9.53033L7 8.06066L8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967L8.06066 7L9.53033 5.53033C9.82322 5.23744 9.82322 4.76256 9.53033 4.46967C9.23744 4.17678 8.76256 4.17678 8.46967 4.46967L7 5.93934L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.75V19C2 20.6569 3.34315 22 5 22H11.25V12.75H2ZM7 20C5.34315 20 4 18.6569 4 17C4 15.3431 5.34315 14 7 14C8.65685 14 10 15.3431 10 17C10 18.6569 8.65685 20 7 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75H22V19C22 20.6569 20.6569 22 19 22H12.75V12.75ZM18.4572 14.5217C18.0318 13.8261 16.9682 13.8261 16.5428 14.5217L14.1497 18.4348C13.7243 19.1304 14.2561 20 15.1069 20H19.893C20.7439 20 21.2757 19.1304 20.8503 18.4348L18.4572 14.5217Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.25V5C22 3.34315 20.6569 2 19 2H12.75V11.25H22ZM14 5C14 4.44772 14.4477 4 15 4H19C19.5523 4 20 4.44772 20 5V9C20 9.55228 19.5523 10 19 10H15C14.4477 10 14 9.55228 14 9V5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubes);
export default __webpack_public_path__ + "static/media/cubes.04a08a594419c5a347acedce61565e72.svg";
export { ForwardRef as ReactComponent };